export type Size = { width: number; height: number };

export const getImageSize = (): Size => {
	return { width: 600, height: 600 };
};
